"use strict";
exports.__esModule = true;
exports.InvoiceActionMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var menu_list_1 = require("../../menu-button/menu-list");
var InvoiceActionMenu = function (_a) {
    var onEdit = _a.onEdit, onDelete = _a.onDelete;
    var menuOptions = [
        {
            label: 'Edit',
            onClick: onEdit
        },
        {
            label: 'Delete',
            onClick: onDelete
        }
    ];
    return (0, jsx_runtime_1.jsx)(menu_list_1.MenuList, { options: menuOptions });
};
exports.InvoiceActionMenu = InvoiceActionMenu;
//# sourceMappingURL=invoice-action-menu.js.map